import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocationsGuardGuard  {
  canLoad(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (environment.enableLocations) {
      // locations enabled so return true
      return true;
  } else {
      return false;
  }
    // UrlTree imported from angular/router as part of sonar
  }
}
